import { getStore } from '@/store';
import util from '@/common/util';

let MarkerClass;
export function getGoogleMarkerClass(maps) {
    if (MarkerClass) {
        return MarkerClass;
    }
    class Marker extends maps.OverlayView {
        constructor({ isVueRef, map, latlng, marker }) {
            super();
            this.isVueRef = isVueRef;
            this.setMap(map);
            this.latlng = latlng;
            this.marker = marker;
            this.dom = null;
        }

        setValue(obj, key, value) {
            if (this.isVueRef) {
                obj[key].value = value;
            } else {
                obj[key] = value;
            }
        }

        destroy() {
            this.setMap(null);
            this.setValue(this.marker, 'parentDom', null);
        }

        onAdd() {
            let panes = this.getPanes();
            let dom = document.createElement('div');
            panes.overlayImage.appendChild(dom);
            this.setValue(this.marker, 'parentDom', dom);
            this.dom = dom;
        }
        draw() {
            var point = this.getProjection().fromLatLngToDivPixel(this.latlng);
            if (point && this.dom) {
                this.dom.style.cssText += ';position:absolute; left: ' + point.x + 'px; top: ' + point.y + 'px;';
            }
        }

        onRemove() {
            if (this.dom) {
                this.dom.parentNode.removeChild(this.dom);
                this.dom = null;
            }
        }
    }
    return (MarkerClass = Marker);
}
export class HereMarker {
    constructor({ isVueRef = false, map, lat, lng, marker, onready, markerClassName = '' }) {
        this.isVueRef = isVueRef;
        this.map = map;
        this.lat = lat;
        this.lng = lng;
        this.marker = marker;
        this.onready = onready;
        this.markerClassName = markerClassName
        this.draw();
    }

    setValue(obj, key, value) {
        if (this.isVueRef) {
            obj[key].value = value;
        } else {
            obj[key] = value;
        }
    }
    
    draw() {
        if (this.marker) {
            var domEle = document.createElement('div');
            domEle.className = 'marker-dom needsclick';
            this.markerClassName && domEle.classList.add(this.markerClassName)
            if (this.marker.className) {
                domEle.classList.add(this.marker.className);
            }
            const _this = this
            var domIcon = new window.H.map.DomIcon(domEle, {
                onAttach: clonedElement => {
                    if (_this.marker) {
                        _this.setValue(_this.marker, 'parentDom', clonedElement);
                        util.call(_this.onready);
                    }
                }
            });
    
            this.domMarker = new window.H.map.DomMarker(
                { lat: this.lat, lng: this.lng },
                {
                    icon: domIcon
                }
            );
            this.map.addObject(this.domMarker);
        }
    }
    
    destroy() {
        if (!this.map) {
            return; 
        }
        this.map.removeObject(this.domMarker);
        this.domMarker = null;
        this.map = null;
        this.lat = null;
        this.lng = null;
        this.setValue(this.marker, 'parentDom', null);
    }
}

export function useMarkerClass() {
    let mapType = getStore('page').page?.map?.type || 'here'

    const MarkerIns = {
        google: {
            offsetY: 0,
            initMapMarker({ applyMap, marker, lat, lng }) {
                lat = lat.value || lat;
                lng = lng.value || lng;
                return applyMap(async([map, maps, siteMap]) => {
                    let markerIns = new (getGoogleMarkerClass(maps))(
                        {
                            isVueRef: true,
                            map,
                            latlng: new maps.LatLng(lat, lng),
                            marker: marker
                        }
                    );
                    // todo: google scroll tap

                    return markerIns;
                });
            },
            getCenter(map) {
                let centerPoint = map.getCenter();
                return {
                    lat: centerPoint.lat(),
                    lng: centerPoint.lng()
                }
            },
            onMarkerClick({ siteMap, map, maps, marker, distance = 200 }) {
                const projection = map.getProjection()
                const bounds = map.getBounds()

                if (!projection || !bounds) {
                    console.warn('The map not ready!')
                    return
                }

                const markerLatLng = marker.getPosition()
                const markerPoint = projection.fromLatLngToPoint(markerLatLng)

                const div = map.getDiv()
                const mapHeight = div.offsetHeight

                const topRight = projection.fromLatLngToPoint(bounds.getNorthEast())
                
                const scale = Math.pow(2, map.getZoom())
                const y = (markerPoint.y - topRight.y) * scale
                if (y > mapHeight - distance) {
                    // 计算偏移量
                    const targetY = mapHeight - distance - 20;
                    const offsetY = y - targetY; // 注意是目标减当前
                    MarkerIns.google.offsetY = -offsetY;
                    MarkerIns.google.moveMapNotSearch({ siteMap, map, maps, offsetY });
                }
            },
            moveMapNotSearch({ siteMap, map, maps, offsetY }) {
                const projection = map.getProjection()
                const centerLatLng = map.getCenter()
                const centerPoint = projection.fromLatLngToPoint(centerLatLng)

                const scale = Math.pow(2, map.getZoom())
                const newCenterPoint = new maps.Point(
                    centerPoint.x,
                    centerPoint.y + offsetY / scale
                )
            
                const newCenterLatLng = projection.fromPointToLatLng(newCenterPoint)
                
                map.panTo(newCenterLatLng)
            },
            restoreToBeforeOffset({ siteMap, map }) {
                if (MarkerIns.google.offsetY) {
                    MarkerIns.google.moveMapNotSearch({ siteMap, map, offsetY: MarkerIns.google.offsetY });
                    MarkerIns.google.offsetY = 0;
                }
            },
        },
        here: {
            offsetY: 0,
            initMapMarker({ applyMap, marker, onready, lat, lng, markerClassName = '' }) {
                lat = lat.value || lat;
                lng = lng.value || lng;
                return applyMap(async([map, maps, siteMap]) => {
                    let markerIns = new HereMarker(
                        {
                            isVueRef: true,
                            map,
                            lat,
                            lng,
                            marker,
                            onready,
                            markerClassName
                        },
                    )
                    // 暂时关闭点击滚动效果
                    // markerIns.domMarker.addEventListener('tap', function(evt) {
                    //     MarkerIns.here.onMarkerClick({ siteMap, map, maps, evt });
                    // });
                    return markerIns;
                });
            },
            getCenter(map) {
                let centerPoint = map.getCenter();
                return {
                    lat: centerPoint.lat,
                    lng: centerPoint.lng
                }
            },
            onMarkerClick({ siteMap, map, evt, distance = 200 }) {
                const markerGeo = evt.target.getGeometry(); // 获取点击的marker经纬度
                const markerScreenPos = map.geoToScreen(markerGeo); // 转成屏幕坐标
                const viewportHeight = map.getViewPort().height; // 当前屏幕高度
            
                let { y } = markerScreenPos;
                if (y > viewportHeight - distance) {
                    // 计算偏移量
                    const targetY = viewportHeight - distance - 20;
                    const offsetY = y - targetY; // 注意是目标减当前
                    MarkerIns.here.offsetY = -offsetY;
                    MarkerIns.here.moveMapNotSearch({ siteMap, map, offsetY });
                }
            },
            moveMapNotSearch({ siteMap, map, offsetY }) {
                // 现在把当前中心点也拿出来
                const currentCenter = map.getCenter();
                const currentCenterScreen = map.geoToScreen(currentCenter);
       
                // 中心点屏幕坐标，应用偏移
                const newCenterScreenX = currentCenterScreen.x;
                const newCenterScreenY = currentCenterScreen.y + offsetY;
       
                // 把新的屏幕坐标转回经纬度
                const newCenterGeo = map.screenToGeo(newCenterScreenX, newCenterScreenY);
       
                siteMap.disableMapChange();
                // 移动地图中心
                map.setCenter(newCenterGeo, true);
                let onceListener = () => {
                    map.removeEventListener('mapviewchangeend', onceListener);
                    onceListener = null;
                    siteMap.enableMapChange();
                };
                map.addEventListener('mapviewchangeend', onceListener);
                // const viewModel = map.getViewModel();
                // viewModel.setLookAtData({ position: newCenterGeo }, true);
            },
            restoreToBeforeOffset({ siteMap, map }) {
                if (MarkerIns.here.offsetY) {
                    MarkerIns.here.moveMapNotSearch({ siteMap, map, offsetY: MarkerIns.here.offsetY });
                    MarkerIns.here.offsetY = 0;
                }
            },
        }
    }

    return {
        ...MarkerIns[mapType]
    }
}